<template>
    <v-container fluid class="admin-page">
        <button class="admin-back" @click="goBack">
            <v-icon size="16">mdi-chevron-left</v-icon>
            Volver al panel
        </button>

        <div class="admin-card">
            <slot />
        </div>

        <div v-if="result" class="admin-result" :class="`admin-result--${result.type}`">
            <v-icon size="18" :color="result.type === 'error' ? 'error' : 'success'">
                {{ result.type === 'error' ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
            </v-icon>
            <span>{{ result.message }}</span>
        </div>
    </v-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
    name: 'AdminPage',
    props: {
        description: {
            type: String,
            default: '',
        },
        result: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapState(['toolbarSubtitle']),
    },
    mounted() {
        this.setToolbarSubtitle(this.description)
    },
    destroyed() {
        const vm = this
        if (vm.toolbarSubtitle === vm.description) vm.setToolbarSubtitle('')
    },
    methods: {
        ...mapMutations(['setToolbarSubtitle']),
        goBack() {
            this.pushRoute({ name: 'admin.home' })
        },
    },
    watch: {
        description(value) {
            this.setToolbarSubtitle(value)
        },
    },
}
</script>

<style scoped>
.admin-page {
    max-width: 860px;
    padding: 16px 20px 40px;
}

.admin-back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 12px 0 8px;
    border-radius: 8px;
    border: 1px solid var(--v-outline2-base);
    background: var(--v-surface-base);
    color: var(--v-txtSecondary-base);
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 18px;
}

.admin-back:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
}

.admin-card {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    padding: 20px;
    box-shadow: 0 1px 0 0 var(--v-outline2-base) inset;
}

.admin-result {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 16px;
    padding: 12px 14px;
    border-radius: 10px;
    font-size: 13px;
    line-height: 1.5;
}

.admin-result--success {
    background: rgba(0, 153, 102, 0.1);
    border: 1px solid rgba(0, 153, 102, 0.3);
    color: var(--v-success-base);
}

.admin-result--error {
    background: rgba(232, 92, 92, 0.1);
    border: 1px solid rgba(232, 92, 92, 0.3);
    color: var(--v-error-base);
}
</style>
